export var convertToVet = function (vetDto) {
    return {
        id: vetDto.id,
        uuid: vetDto.uuid,
        businessName: vetDto.business_name,
        name: vetDto.name,
        phone: vetDto.phone,
        email: vetDto.email,
        address: vetDto.address,
        active: vetDto.active,
        deleted: vetDto.deleted,
    };
};
export var convertToBody = function (vet) {
    return {
        id: vet.id,
        uuid: vet.uuid,
        business_name: vet.businessName,
        name: vet.name,
        email: vet.email,
        phone: vet.phone,
        address: vet.address,
        active: vet.active,
        deleted: vet.deleted,
    };
};
